import { createFileRoute } from '@tanstack/react-router';

import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';
import { IncidenteDetail } from '@/features/compliance/components/incidente-detail';

export const Route = createFileRoute('/_app/compliance/incidentes/$id')({
  component: ComplianceIncidenteDetailRoute,
});

function ComplianceIncidenteDetailRoute() {
  const { id } = Route.useParams();
  return (
    <div className="flex flex-col gap-6">
      <ComplianceSectionTabs />
      <IncidenteDetail incidenteId={id} />
    </div>
  );
}
